import React from 'react';
import TextBoxQuestion from './TextBoxQuestion.jsx';
import FleetAccountsQuestion from './FleetAccountsQuestion.jsx';
import MultipleChoiceQuestion from './MultipleChoiceQuestion.jsx';
import DropDownQuestion from './DropDownQuestion.jsx';
import CheckboxesQuestion from './CheckboxesQuestion.jsx';
import CheckboxesWithOtherQuestion from './CheckboxesWithOtherQuestion.jsx';
import FileUploadQuestion from './FileUploadQuestion.jsx';
import ProfilePhotoQuestion from './ProfilePhotoQuestion.jsx';
import CheckboxesWithTextbox from './CheckboxesWithTextbox.jsx';
import { LoadingIcon } from '../../Common/Loading_Icon.js';

export function DisplayQuestion(props) {

    if(props.page == 'multiple_choice') {
        return (
        	<MultipleChoiceQuestion page={props.page} question={props.question} responses={props.responses} errors={props.errors} options={props.options} loadSurvey={props.loadSurvey} handleResponse={props.handleResponse} />
    	)
    } else if (props.page == 'textbox') {
        return (
        	<TextBoxQuestion page={props.page} question={props.question} responses={props.responses} errors={props.errors} options={props.options} loadSurvey={props.loadSurvey} handleResponse={props.handleResponse} />
    	)
    } else if(props.page == 'checkboxes') {
        return (
        	<CheckboxesQuestion page={props.page} question={props.question} responses={props.responses} errors={props.errors} options={props.options} loadSurvey={props.loadSurvey} handleResponse={props.handleResponse} />
    	)
    } else if(props.page == 'drop_down') {
        return (
        	<DropDownQuestion page={props.page} question={props.question} responses={props.responses} errors={props.errors} options={props.options} loadSurvey={props.loadSurvey} handleResponse={props.handleResponse} />
    	)
    } else if(props.page == 'file_upload') {
        return (
        	<FileUploadQuestion page={props.page} question={props.question} responses={props.responses} errors={props.errors} options={props.options} loadSurvey={props.loadSurvey} handleResponse={props.handleResponse} />
		)
	} else if(props.page == 'profile_photo_upload') {
        return (
        	<ProfilePhotoQuestion page={props.page} question={props.question} history={props.history} responses={props.responses} errors={props.errors} options={props.options} loadSurvey={props.loadSurvey} handleResponse={props.handleResponse} />
		)
	} else if(props.page === 'checkboxes_with_other') {
		return(
			<CheckboxesWithOtherQuestion page={props.page} question={props.question} responses={props.responses} errors={props.errors} options={props.options} loadSurvey={props.loadSurvey} handleResponse={props.handleResponse} other={true} />
		)
	} else if(props.page === 'checkboxes_with_textbox') {
		return(
			<CheckboxesWithTextbox page={props.page} question={props.question} responses={props.responses} errors={props.errors} options={props.options} loadSurvey={props.loadSurvey} handleResponse={props.handleResponse} />
		)
    } else if(props.page === 'fleet_account_numbers') {
		return(
			<FleetAccountsQuestion page={props.page} question={props.question} responses={props.responses} errors={props.errors} options={props.options} loadSurvey={props.loadSurvey} handleResponse={props.handleResponse} />
		)
    } else if(props.page == 'success') {
		props.history.push('/mobilevalidation')
		return(
			<LoadingIcon />
		)
    } else {
		return (
			<div></div>
		)
	}
}

export function BackButton(props) {

	if(props.question.question_orders.length == 0 || props.question.question_orders[0].Question_Order != 1) {
		return (
			<div className='back-btn'>
				<a><i className="fas fa-long-arrow-alt-left" aria-hidden='true' onClick={props.loadSurvey}></i></a>
			</div>
		)
	} else {
		return (
			<span />
		)
	}
}

export function ForwardButton(props) {
	return (
		<div className="enable">
			<a id='forward-button' onClick={props.localValidation} className={ jQuery.isEmptyObject(props.responses) && (props.question.Validation).includes('required') ? 'button primary' : 'button primary'}>
				<i className="fas fa-long-arrow-alt-right"></i>
			</a>
		</div>
	)
}

export function DisplayErrors(props) {
	if(props.errors != undefined && props.errors.length > 0) {
		return (
			<div>
		        <ul>
		            { props.errors.map((error) =>
		                <li className = "alert-message">{ error }</li>
		            ) }
		        </ul>
		    </div>
		)
	} else {
		return (
			<span></span>
		)
	}
}

export function loadSurvey() {

}

export function localValidation() {

}